import React from 'react';
import { Container, Typography, Paper, Box, Breadcrumbs, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import GavelIcon from '@mui/icons-material/Gavel';

const Terms = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Box sx={{ mb: 4 }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link 
            component={RouterLink} 
            to="/"
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            <HomeIcon sx={{ mr: 0.5, fontSize: 20 }} />
            Home
          </Link>
          <Typography color="text.primary" sx={{ display: 'flex', alignItems: 'center' }}>
            <GavelIcon sx={{ mr: 0.5, fontSize: 20 }} />
            Terms of Service
          </Typography>
        </Breadcrumbs>
      </Box>

      <Paper elevation={2} sx={{ p: 4, borderRadius: 2 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ color: 'primary.main', fontWeight: 600 }}>
          Terms of Service
        </Typography>
        
        <Typography variant="body1" paragraph sx={{ mt: 4 }}>
          Last Updated: {new Date().toLocaleDateString()}
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          1. Introduction
        </Typography>
        <Typography variant="body1" paragraph>
          Welcome to Meal Maestro. By accessing our website and using our services, you agree to comply with and be bound by the following terms and conditions. Please read these Terms carefully before using our platform.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          2. Acceptance of Terms
        </Typography>
        <Typography variant="body1" paragraph>
          By accessing or using Meal Maestro, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing this site.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          3. Use License
        </Typography>
        <Typography variant="body1" paragraph>
          Permission is granted to temporarily use Meal Maestro for personal, non-commercial use only. This is the grant of a license, not a transfer of title. Under this license, you may not:
        </Typography>
        <Typography component="ul" sx={{ pl: 4 }}>
          <li>Modify or copy the materials</li>
          <li>Use the materials for any commercial purpose</li>
          <li>Attempt to decompile or reverse engineer any software contained on Meal Maestro</li>
          <li>Remove any copyright or other proprietary notations from the materials</li>
          <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          4. User Content
        </Typography>
        <Typography variant="body1" paragraph>
          When you create, upload, post, send, receive, store, or otherwise make available any content on our platform, you grant Meal Maestro a worldwide, non-exclusive, royalty-free license to use, copy, modify, create derivative works based on, distribute, publicly display, and otherwise exploit such content in connection with operating and providing the services.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          5. Disclaimer
        </Typography>
        <Typography variant="body1" paragraph>
          The materials on Meal Maestro are provided on an 'as is' basis. We make no warranties, expressed or implied, and hereby disclaim and negate all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          6. Limitations
        </Typography>
        <Typography variant="body1" paragraph>
          In no event shall Meal Maestro or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on our website, even if we or an authorized representative has been notified orally or in writing of the possibility of such damage.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          7. Revisions and Errata
        </Typography>
        <Typography variant="body1" paragraph>
          The materials appearing on Meal Maestro could include technical, typographical, or photographic errors. We do not warrant that any of the materials are accurate, complete, or current. We may make changes to the materials at any time without notice.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          8. Contact Us
        </Typography>
        <Typography variant="body1" paragraph>
          If you have any questions about these Terms, please contact us at support@mealmaestro.com.
        </Typography>
      </Paper>
    </Container>
  );
};

export default Terms;
